import { r as c, p as b, h, H as f, g as u } from "./main-bb89b2f2.js";
import { g as d, p as g, l as p, C as a, r as m, b as y, e as C } from "./chart-tooltip-d075b66a-62f34707.js";
import { p as S } from "./chartjs-plugin-datalabels.esm-a93be9f2-a4213e17.js";
import "vue";
const z = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block;height:100%}.static{position:static}.grid{display:grid}.border{border-width:1px}", k = z, I = class {
  constructor(i) {
    c(this, i), this.defaultLabelFormat = (t) => `${t.dataset.label}: ${t.formattedValue}${this.unit}`, this.data = void 0, this.showLegend = !0, this.showTooltips = !0, this.unit = "", this.showDataLabels = !0, this.labelDirection = "auto", this.legendPosition = "bottom", this.barPercentage = 0.9, this.headlineFontSize = 20, this.subheadlineFontSize = 14, this.dataLabelFontSize = 14, this.labelFontSize = 16;
  }
  dataWatcher(i) {
    try {
      const t = b(i), e = Math.abs(this.barPercentage - 0.9) > 1e-3;
      this.myChartInstance.data.labels = t.labels, this.myChartInstance.data.topLabels = t.topLabels, this.myChartInstance.data.topLabelsSubHeadlines = t.topLabelsSubHeadlines, this.myChartInstance.data.datasets = [], this.myChartInstance.data.datasets = t.values.map((n, l) => {
        var s, r;
        const o = (s = n.color) !== null && s !== void 0 ? s : d(l);
        return {
          data: n.data,
          label: n.label,
          backgroundColor: o,
          labelColor: (r = n.labelColor) !== null && r !== void 0 ? r : l === 1 ? "#fff" : "#000",
          barPercentage: e ? this.barPercentage : 0.9,
          categoryPercentage: e ? 1 : 0.8,
          borderWidth: 2,
          borderColor: "#ffffff",
          hoverBackgroundColor: this.showTooltips ? g(o, 15) : o,
          hoverBorderWidth: 2,
          hoverBorderColor: "#ffffff"
        };
      }), this.myChartInstance.update();
    } catch (t) {
      console.error("[PatternlibStackedChart] Error parsing data", t);
    }
  }
  labelDirectionWatcher() {
    this.myChartInstance.config.options.scales.x.ticks.minRotation = this.labelDirection === "vertical" ? 90 : this.labelDirection === "skew" ? 45 : 0, this.myChartInstance.update();
  }
  barPercentageWatcher() {
    this.myChartInstance.update();
  }
  labelFontSizeWatcher() {
    this.myChartInstance.config.options.scales.x.ticks.font.size = this.labelFontSize, this.myChartInstance.update();
  }
  headlineFontSizeWatcher() {
    this.myChartInstance.config.options.plugins.datalabels.labels.index.font.size = this.headlineFontSize, this.myChartInstance.update();
  }
  subheadlineFontSizeWatcher() {
    this.myChartInstance.config.options.plugins.datalabels.labels.name.font.size = this.subheadlineFontSize, this.myChartInstance.update();
  }
  dataLabelFontSizeWatcher() {
    this.myChartInstance.config.options.plugins.datalabels.labels.title.font.size = this.dataLabelFontSize, this.myChartInstance.update();
  }
  componentDidLoad() {
    this.themeChangeObserver = p(() => {
      this.myChartInstance.data.datasets.forEach((t, e) => {
        t.backgroundColor = d(e);
      }), this.myChartInstance.update();
    }), a.register(...m, y), a.defaults.font.family = "LiebherrText-Regular", a.defaults.font.size = 16, a.defaults.font.weight = "bold", a.defaults.color = "#000", this.canvas = this.hostElement.shadowRoot.querySelector("canvas");
    const i = {
      plugins: [S],
      type: "bar",
      data: {
        labels: [],
        datasets: [
          {
            labels: [],
            data: []
          }
        ]
      },
      options: {
        indexAxis: "x",
        responsive: !0,
        maintainAspectRatio: !1,
        layout: {
          padding: {
            left: 0,
            top: 40
          }
        },
        plugins: {
          datalabels: {
            formatter: (t, e) => this.showDataLabels ? `${t}${this.unit}` : "",
            color: function(t) {
              return t.dataset.labelColor;
            },
            anchor: "start",
            align: "top",
            labels: {
              index: {
                align: "end",
                anchor: "end",
                font: { size: this.headlineFontSize, family: "LiebherrHead-Black", weight: "900" },
                formatter: function(t, e) {
                  return e.datasetIndex === e.chart.config.data.datasets.length - 1 && e.chart.config.data.topLabels ? e.chart.config.data.topLabels[e.dataIndex] : null;
                },
                color: "black",
                offset: function(t) {
                  return t.datasetIndex === t.chart.config.data.datasets.length - 1 && t.chart.config.data.topLabelsSubHeadlines && t.chart.config.data.topLabelsSubHeadlines[t.dataIndex] != null ? 20 : 4;
                }
              },
              name: {
                align: "end",
                anchor: "end",
                font: { size: this.subheadlineFontSize, family: "LiebherrText-Regular", weight: "400" },
                formatter: function(t, e) {
                  return e.datasetIndex === e.chart.config.data.datasets.length - 1 && e.chart.config.data.topLabelsSubHeadlines ? e.chart.config.data.topLabelsSubHeadlines[e.dataIndex] : null;
                },
                color: "black",
                offset: 1
              },
              title: {
                font: { size: this.dataLabelFontSize, family: "LiebherrText-Bold", weight: "700" }
              }
            }
          },
          legend: {
            display: this.showLegend,
            position: this.legendPosition
          },
          tooltip: {
            enabled: !1,
            position: "nearest",
            alignment: "left",
            tooltipAdjustment: 38,
            external: this.showTooltips ? C : null,
            callbacks: {
              label: this.defaultLabelFormat
            }
          }
        },
        scales: {
          x: {
            stacked: !0,
            grid: { display: !1 },
            border: {
              display: !1
            },
            ticks: {
              autoSkip: !1,
              autoSkipPadding: 0,
              maxRotation: 90,
              minRotation: this.labelDirection === "vertical" ? 90 : this.labelDirection === "skew" ? 45 : 0,
              afterFit: (t) => t.height = 120,
              font: { size: this.labelFontSize, family: "LiebherrText-Bold", weight: "700" }
            }
          },
          y: {
            grid: { display: !1 },
            stacked: !0,
            ticks: {
              display: !1
            },
            border: {
              display: !1
            },
            title: {
              display: !0
            },
            offset: !0
          }
        }
      }
    };
    this.myChartInstance = new a(this.canvas, i), this.dataWatcher(this.data);
  }
  disconnectedCallback() {
    this.themeChangeObserver.disconnect();
  }
  render() {
    return h(f, { key: "bc1964688bedf9fc7282a0bc336ff726a8361e3e" }, h("canvas", { key: "bd94638b52f9f2f920d075c75ec41b22c1b4c092" }));
  }
  get hostElement() {
    return u(this);
  }
  static get watchers() {
    return {
      data: ["dataWatcher"],
      labelDirection: ["labelDirectionWatcher"],
      barPercentage: ["barPercentageWatcher"],
      labelFontSize: ["labelFontSizeWatcher"],
      headlineFontSize: ["headlineFontSizeWatcher"],
      subheadlineFontSize: ["subheadlineFontSizeWatcher"],
      dataLabelFontSize: ["dataLabelFontSizeWatcher"]
    };
  }
};
I.style = k;
export {
  I as patternlib_stacked_bar_chart
};
